import React from 'react'
import { DateRangePickerSeeker, disabledAfterToday } from "@ui-seeker/core"
import { europcarDateRange } from "Pages/BusinessLogistics/Analytics/Page/@signals"

export default function EuropcarDateRangeFilter() {

	return <DateRangePickerSeeker
		multiple
		value={europcarDateRange.value}
		onChange={e => europcarDateRange.value = e}
		shouldDisableDate={disabledAfterToday()}
		label="Date Range"
	/>
}